import $ from 'jquery';

// Handles Report Layout / Report Provisioning UI initialization for both licensee and state contexts.
// The #layout-ui element carries all required config as data-* attributes, including
// data-layout-script-url (the external JS to load) and data-init-function (function name to call).
$(document).ready(function() {
  const layoutUi = document.getElementById('layout-ui');
  if (!layoutUi) return;

  const d = layoutUi.dataset;
  const scriptUrl = d.layoutScriptUrl;
  if (!scriptUrl) return;

  $.getScript(scriptUrl, function() {
    setTimeout(function() {
      $('.alert').fadeOut();
    }, 2000);

    const config = {};

    if (d.layoutApiHost)       config.layout_api_host       = d.layoutApiHost;
    if (d.layoutApiToken)      config.layout_api_token      = d.layoutApiToken;
    if (d.narxcareReportsHost) config.narxcare_reports_host = d.narxcareReportsHost;
    if (d.narxcareReportsToken) config.narxcare_reports_token = d.narxcareReportsToken;
    if (d.gatewayHost)         config.gateway_host          = d.gatewayHost;
    if (d.gatewayApiToken)     config.gateway_api_token     = d.gatewayApiToken;
    if (d.licenseeId)          config.licensee_id           = d.licenseeId;
    if (d.licenseeName)        config.licensee_name         = d.licenseeName;
    if (d.licenseeStateCode)   config.licensee_state_code   = d.licenseeStateCode;
    if (d.roles)               config.roles                 = JSON.parse(d.roles);
    if (d.statesWithEnabledTreatmentProgram)
      config.states_with_enabled_treatment_program = JSON.parse(d.statesWithEnabledTreatmentProgram);
    if (d.statesWithOpenbeds)
      config.states_with_openbeds = JSON.parse(d.statesWithOpenbeds);

    config.system_admin                  = d.systemAdmin === 'true';
    config.read_only                     = d.readOnly === 'true';
    config.communications_module_enabled = d.communicationsModuleEnabled === 'true';
    if (d.openbedsEnabled !== undefined)   config.openbeds_enabled       = d.openbedsEnabled === 'true';
    if (d.careNavigationButton !== undefined) config.care_navigation_button = d.careNavigationButton === 'true';

    const initFn = d.initFunction && window[d.initFunction];
    if (typeof initFn === 'function') {
      initFn(layoutUi, config);
    }
  });
});
